export const translations = {
  sv: {
    ariaLabel: 'Spela eller pausa video',
  },
  en: {
    ariaLabel: 'Play or pause video',
  },
  da: {
    ariaLabel: 'Afspil eller sæt video på pause',
  },
  no: {
    ariaLabel: 'Spill av eller sett video på pause',
  },
  fi: {
    ariaLabel: 'Toista tai keskeytä video',
  },
  de: {
    ariaLabel: 'Video abspielen oder anhalten',
  },
  zh: {
    sharelabel: 'Play or pause video',
  },
  it: {
    sharelabel: 'Play or pause video',
  },
  nl: {
    sharelabel: 'Play or pause video',
  },
};
